<template>
  <b-modal
    v-if="reVisible"
    v-model="reVisible"
    :body-class="bodyClass"
    :footer-class="footerClass"
    cancel-variant="outline-secondary"
    :size="size"
    centered
    :title="title ? title : i18n(pageKey + 'Prompt')"
    :no-close-on-backdrop="noBackClose"
    :modal-class="{
      ...modalClass,
      'modal-header-hide': !header,
      'modal-footer-hide': !footer,
    }"
  >
    <div v-if="pageKey === 'columnOption'" class="demo-inline-spacing">
      <template v-for="col in columns">
        <b-form-checkbox
          v-if="col.field !== '_menu' && !col.columnOptionHide"
          :key="col.field"
          v-model="selected"
          class="mt-1 pr-1"
          :value="col.field"
        >
          {{ col.label }}
        </b-form-checkbox>
      </template>
    </div>
    <template v-else-if="$scopedSlots.content">
      <slot name="content" />
    </template>
    <template v-else-if="message">
      {{ message }}
    </template>
    <template v-else>
      {{ i18n('message.' + pageKey) }}
    </template>
    <template #modal-footer>
      <b-button variant="outline-primary" size="sm" @click="handleVisible">
        {{ i18n('btns.cancel') }}
      </b-button>
      <b-button
        variant="primary"
        size="sm"
        :disabled="disabled"
        @mouseenter="$emit('confirmEnter')"
        @mouseleave="$emit('confirmLeave')"
        @click="modelConfirm"
      >
        {{ i18n('btns.confirm') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BFormCheckbox, BButton } from 'bootstrap-vue'

export default {
  name: 'CModal',
  components: {
    BModal,
    BFormCheckbox,
    BButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    pageKey: {
      type: String,
      default: 'add',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    selectedColumns: {
      type: Array,
      default: () => [],
    },
    message: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    size: {
      type: String,
      default: '',
    },
    header: {
      type: Boolean,
      default: true,
    },
    footer: {
      type: Boolean,
      default: true,
    },
    bodyClass: {
      type: String,
      default: '',
    },
    modalClass: {
      type: Object,
      default: () => {},
    },
    footerClass: {
      type: String,
      default: '',
    },
    noBackClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
      reVisible: this.visible,
      defaultOverflowY: 'auto',
      disabled: false,
    }
  },
  watch: {
    selectedColumns: {
      handler(e) {
        this.selected = e
      },
      deep: true,
    },
    visible: {
      handler(e) {
        this.reVisible = e
        document.body.style.overflowY = e ? 'hidden' : this.defaultOverflowY
      },
      deep: true,
    },
    reVisible: {
      handler(e) {
        if (!e) {
          this.$emit('close')
        }
      },
      deep: true,
    },
  },
  created() {
    this.defaultOverflowY = document.body.style.overflowY
  },
  mounted() {},
  methods: {
    handleVisible() {
      this.$emit('close')
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
    modelConfirm() {
      // eslint-disable-next-line no-shadow
      const done = (bool) => {
        if (this.disabled) {
          this.disabled = false
        }
        this.disabled = bool
      }
      this.$emit('modelConfirm', this.selected, done)
    },
  },
}
</script>
<style lang="scss">
.modal-header-hide {
  .modal-header {
    display: none;
  }
}
.modal-footer-hide {
  .modal-footer {
    display: none;
  }
}
</style>
